import React from "react";
import Icon from 'react-web-vector-icons';

import './Modal.scss';

const Modal = props => {
	const {children, showClose, onClose, className} = props;

	// Handle ESC key press
	React.useEffect(() => {
		const handleEsc = (event) => {
			if (event.keyCode === 27 && showClose !== false && onClose) {
				onClose();
			}
		};
		window.addEventListener('keydown', handleEsc);
		return () => {
			window.removeEventListener('keydown', handleEsc);
		};
	}, [onClose, showClose]);

	// Handle click outside
	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget && showClose !== false && onClose) {
			onClose();
		}
	};

	return (
		<div className="modal-wrapper" onClick={handleOverlayClick}>
			<div className={`modal-container ${className || ''}`}>
				{
					showClose !== false &&
					<div className="modal-close-icon" onClick={onClose} aria-label="Close" role="button" tabIndex={0}>
						<Icon name="close" font="AntDesign" size={12} />
					</div>
				}
				{ children }
			</div>
		</div>
	)
};

export default Modal;